import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

@Pipe({
    name: 'timeAgo',
    standalone: false
})
export class TimeAgoPipe implements PipeTransform {
    transform(value: string | Date): string {
        return moment(moment.utc(value)).fromNow();
    }
}
